import { render } from "./TheCurrencyList.vue?vue&type=template&id=5bbb3aa4&scoped=true&ts=true"
import script from "./TheCurrencyList.vue?vue&type=script&lang=ts"
export * from "./TheCurrencyList.vue?vue&type=script&lang=ts"

import "./TheCurrencyList.vue?vue&type=style&index=0&id=5bbb3aa4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbb3aa4"]])

export default __exports__